
























































































    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { Debounce } from 'lodash-decorators';
    import axios from 'axios';
    import { api } from '@/api';
import { Action, Getter } from 'vuex-class';

    @Component
    export default class BabysitterPaymentForm extends Vue {

        public babysitter: any = null;
        public babysitterRules: ( (v: object) => void )[] = [
            (v: object) => !!v || 'Babysitter is required',
        ];
        public babysitters: any[] = [];
        public babysitterName: any = null;
        public babysitterLoading: boolean = false;

        public euros: number = 0;
        public minEuros: number = 1;
        public eurosRules: ( (v: number) => void )[] = [
            (v) => v >= this.minEuros || 'Invalid amount of RSD.',
        ]

        public parentShiftId: number | null = null;
        public transactionSubtype: string | null = null;

        public note: string = '';

        public $refs!: { // fix for this.$refs.form.valdiate(); TS error
            euros: HTMLFormElement
        }

        @Watch('babysitterName')
        @Debounce(500)
        onBabysitterNameChange( value: string ): void {

            let params = {
                paginate: 'no',
                name: value
            }
            this.babysitterLoading = true;

            axios.get(api.path('v1.admin.babysitters'), { params: params })
                .then( res => {
                    this.babysitterLoading = false;
                    this.babysitters = res.data.data;
                });
        }

        public getPayload() {
            return {
                amount: this.euros,
                transaction_type: 2,
                note: this.note,
                parent_shift_id: this.parentShiftId,
                transaction_subtype: this.transactionSubtype
            }            
        }

        public makePayment() {

            if (!this.$refs.euros.validate()) return;

            let payload = this.getPayload();

            axios.post(api.path('v1.admin.babysitters.createTransaction', { id:  this.babysitter.id }), payload)
                .then( res => {
                    this.$toast.success(res.data.message);
                    this.$refs.euros.reset();
                    this.$refs.euros.resetValidation();
                });
        }

        @Action('transactionSubtypes/fetch') fetchTransactionSubtypes: any;
        @Getter('transactionSubtypes/transacitonSubtypes') transactionSubtypes: any;

        public transactionSubtypeReadable(subtype: any) {
            return this.$t(`transaction_subtype.${subtype.value}`);
        }

        public mounted() {
            this.fetchTransactionSubtypes();
        }
    }

